import React from 'react';
import { Alert } from 'antd';
import Loader from 'src/components/loader.component';
import { NumericFormat } from 'react-number-format';

const Kpis = (props) => {
    const {usedCredit,availableCredit,days, setDays}=props?.propsData;
    return (
        <div className="container-fluid summary-container p-3">
            <div className="row g-3">
                {/* Available Credit */}
                <div className="col-md-4">
                    <div className="summary-container p-3 text-white">
                        {availableCredit.loading && <Loader />}
                        {availableCredit.error &&
                            <Alert
                                description={availableCredit.error}
                                type="error"
                                showIcon
                            />
                        }
                        {!availableCredit.loading && !availableCredit.error && (
                            <>
                                <p className="mb-1">Available Credit</p>
                                <h5 className="fw-semibold">
                                    <NumericFormat
                                        value={availableCredit?.data?.availableCredit || 0}
                                        displayType="text"
                                        thousandSeparator
                                        decimalScale={4}
                                    />
                                </h5>
                            </>
                        )}
                    </div>
                </div>

                {/* Used Credit + Filters */}
                <div className="col-md-8">
                    <div className="summary-container p-3 text-white">
                        {usedCredit.loading && <Loader />}
                        {usedCredit.error &&
                            <Alert
                                description={usedCredit.error}
                                type="error"
                                showIcon
                                closable
                            />
                        }
                        {!usedCredit.loading && !usedCredit.error && (
                            <div className="d-flex justify-content-between mb-3 flex-wrap">
                                <div>
                                    <p className="mb-1">Used Credit</p>
                                    <h5 className="fw-semibold">
                                        <NumericFormat
                                            value={usedCredit.data || 0}
                                            displayType="text"
                                            thousandSeparator
                                            decimalScale={4}
                                        />
                                    </h5>
                                </div>
                                <div className="btn-group custom-energy-btn" role="group">
                                    {[1, 7, 30].map(val => (
                                        <button
                                            key={val}
                                            className={`btn ${days === val ? 'primary-btn text-white px-0 py-0' : 'primary-btn-outline-primary border-color text-light px-2 py-0'}`}
                                            onClick={() => setDays(val)}
                                        >
                                            {val === 1 ? '1 Day' : `${val} Days`}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Kpis;
